import React, {Component} from 'react';
import { Howler } from 'howler';
import strings from '../../strings';
import {updateStepData} from 'api';
import {se_numbers_trial,se_numbers_answers,} from './assets';
import listen from '../../assets/listen.png';
import { Howl } from 'howler';
import './styles.scss';

class Trial extends Component {
	constructor(props) {
		super(props);
		this._feedbackPlayed = false;
		this._lastStep = null;
		switch (strings.getLanguage()) {
			case 'nn':
				this.assets = se_numbers_trial;
				this.answers_stuff = se_numbers_answers
				break;
			case 'se':
				this.assets = se_numbers_trial;
				this.answers_stuff = se_numbers_answers
				break;
			case 'de':
				this.assets = se_numbers_trial;
				this.answers_stuff = se_numbers_answers
				break;
			case 'no':
			default:
				this.assets = se_numbers_trial;
				this.answers_stuff = se_numbers_answers
				break;
		}
	}

	componentDidUpdate(prevProps) {
  const sd = this.props.stepData || {};

  if (this._lastStep !== this.props.currentStep) {
    this._feedbackPlayed = false;
    this._lastStep = this.props.currentStep;
  }

  if (sd.feedbackDone === false && typeof sd.correct === 'boolean' && !this._feedbackPlayed) {
    this._feedbackPlayed = true;
    this.playFeedback(sd.correct === true);
    return;
  }

  if (this.props.currentStep !== prevProps.currentStep) {
    this.startNewTask(this.props.currentStep);
  }
}

	componentDidMount() {
		if (this.button) this.button.click();
		this.initializeAudio();
	}
	componentWillUnmount() {
		this.stopSounds();
		clearTimeout(this.timeout);
	}

	initializeAudio = () => {
  Object.values(this.assets).forEach((a) => a?.load?.());
  Object.values(this.answers_stuff).forEach((a) => a?.load?.());

  this.timeout = setTimeout(
    () => this.startNewTask(this.props.currentStep),
    1000
  );
};


playFeedback = (correct) => {
  this.stopSounds();

  const audioFile = correct
    ? this.answers_stuff?.correct1
    : this.answers_stuff?.incorrect1;

  if (!audioFile) {
    updateStepData({ feedbackDone: true, answered: true });
    return;
  }

  // compute a safe fallback timeout (duration + buffer)
  const dur = typeof audioFile.duration === 'function' ? audioFile.duration() : 0;
  const hardMs = Math.max(15000, Math.ceil((dur || 0) * 1000) + 1500);

  const hardTimeout = setTimeout(() => {
    updateStepData({ feedbackDone: true, answered: true });
  }, hardMs);

  const done = () => {
    clearTimeout(hardTimeout);
    // now allow the system to advance
    updateStepData({ feedbackDone: true, answered: true });
  };

  // clean listeners (avoid stacking)
  if (typeof audioFile.off === 'function') {
    audioFile.off('end');
    audioFile.off('loaderror');
    audioFile.off('playerror');
  }
  console.log('PlayFeedBack')
  audioFile.once?.('end', done);
  audioFile.once?.('loaderror', done);
  audioFile.once?.('playerror', done);

  audioFile.play();
};

	startNewTask = (taskNumber) => {
		this.stopSounds();
		this.playNumbers(taskNumber);
	};

	playNumbers = (sound) => {
  const s = this.assets?.[sound];
  if (!s || typeof s.play !== 'function') {
    console.warn('[WM] Missing number trial audio for step:', sound, this.assets);
    return;
  }
  s.play();
};

	stopSounds = () => {
  const all = [...Object.values(this.assets), ...Object.values(this.answers_stuff)]
    .filter(Boolean);

  for (const s of all) {
    // Howler
    if (typeof s.stop === 'function') {
      s.stop();
      continue;
    }
    // HTMLAudioElement fallback
    if (typeof s.pause === 'function') {
      s.pause();
      try {
        if (typeof s.currentTime === 'number') s.currentTime = 0;
      } catch (_) {}
    }
  }
};

	render() {
		return (
			<div className="WorkingMemory">
				<img className="listen-image" src={listen} alt="" />
				<p>{strings.wsn_test1}</p>
			</div>
		);
	}
}

export default Trial;
